import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ComponentProps } from "react";

type TextAreaFieldProps = ComponentProps<typeof Textarea> & {
  label?: string;
  error?: string;
};

const TextAreaField = ({ label, ...props }: TextAreaFieldProps) => {
  return (
    <div className="flex w-full flex-col gap-3">
      {label && <Label>{label}</Label>}
      <Textarea
        className={`${props.error ? "border-red-500 focus-visible:border-red-500 focus-visible:ring-red-500/50" : ""}`}
        placeholder={props.placeholder}
        name={props.name}
        onChange={props.onChange}
        value={props.value}
        defaultValue={props.defaultValue}
        maxLength={props.maxLength ?? 300}
      />
      {props.error && (
        <span className="pt-1 pl-1 text-xs text-red-500">{props.error}</span>
      )}
    </div>
  );
};

export default TextAreaField;
